var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"data-component":"CsFileDialog"}},[_c('input',{ref:"input",staticClass:"hidden",attrs:{"type":"file","multiple":"","accept":_vm.accept},on:{"change":_setup.onAddFile}}),_vm._v(" "),_vm._t("default",null,{"open":_setup.open})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }